<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    async created () {
        const response = await this.$http().get('quality/config')
        this.$store.state.quality.complaintCategories = response.data.complaintCategories
        this.$store.state.quality.campaigns = response.data.campaigns
        this.$store.state.quality.teams = response.data.teams
    }
}
</script>